<template>
    <div>
        <DataLabel item="" :icon-class="iconClass">
            <TagsBadges :tags="selectedTags" :none="$t('common.labels.tags.nil')" />
        </DataLabel>
    </div>
</template>

<script>
import DataLabel from '@/js/components/common/labels/DataLabel';
import TagsBadges from '@/js/components/common/badges/TagsBadges';

export default {
    name: 'TagsLabel',

    components: {DataLabel, TagsBadges},

    props: {
        tags: {type: Array, required: true},
        hideIcon: {type: Boolean},
        isConfiguration: {type: Boolean},
    },

    computed: {
        iconClass() {
            if (this.hideIcon) {
                return null;
            }

            if (this.isConfiguration) {
                return 'fa fa-fw fa-cogs';
            }

            return 'fa fa-fw fa-tag';
        },

        selectedTags() {
            return this.tags.filter((tag) => tag.is_configuration === Boolean(this.isConfiguration));
        },
    },
};
</script>
